import { useEffect, useContext, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/user.context";
import { Outlet } from "react-router-dom";
import NavBar from "../../../components/navigation-bar/nav-bar.component.group";
import LoadingScreen from "../../../components/LoadingScreen";
import { useAppTheme } from "../../../context/theme.context";
const Group = () => {
  const { currentUser } = useContext(AuthContext);
  const { colors } = useAppTheme();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser === null) {
      navigate("/sign-in");
    }
  }, [currentUser, navigate]);

  return (
    <div style={{ backgroundColor: colors.background.page, minHeight: '100vh' }}>
      <NavBar />
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default Group;